<script lang="ts">
  import { Col, Container, Row } from "sveltestrap";

  /* 
  const entities = [
    ["탄소배출", "농업에 관련된 환경문제 탄소배출감소 연구 및 개발"],
    ["AI자동예측시스템", "빅데이터를 기반으로 작물을 관리하는 자동예측 시스템"],
    ["식물공장", "공간과 환경에 제한이 없는 공장형태의 재배시스템 구축"],
    ["ESG 경영", "환경과 사회에 공헌하는 지속적인 환경보존 사업"],
  ]; 
  */

  const entities = [
    ["탄소배출", "농업 관련 환경문제, 탄소배출저감<br/>연구 및 개발"],
    ["AI자동예측시스템", "빅데이터 기반 농산물을 재배하는 자동예측시스템"],
    ["식물공장", "공간과 환경에 제한이 없는<br/>공장형태의 재배시스템 구축"],
    ["ESG 경영", "환경과 사회에 공헌하는 지속적인 환경보존 사업"],
  ];
</script>

<Container>
  <div class="mainview mx-5">
    <Row>
      {#each entities as item, index}
        <Col xs="12" sm="3" class="text-center">
          <img
            alt="{item[0]} 아이콘"
            src="/images/main/s2_icon{index + 1}.png"
          />
          <h2>{item[0]}</h2>
          <div class="text">
            {@html item[1]}
          </div>
        </Col>
      {/each}
    </Row>
  </div>
</Container>

<style lang="scss">
  .text {
    word-break: keep-all;
  }

  img {
    width: 40%;
  }
</style>
